import React, {useState, useContext, useEffect} from "react";
import Box from "@mui/material/Box";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {LoadingContext} from "@hoc/loading";
import {MessageContext} from "@hoc/messageNotification";
import {getTotalIssued} from '@api/barcodes';
import Typography from "@mui/material/Typography";

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    main: {
        margin: '5px 0'
    }

});

export const BenefitStatistics = ({data}) => {
        
        const [benefitId] = useState(data);
        const classes = useStyles();
        const [statisticsObj, setStatisticsObj] = useState()
        const {setLoading} = useContext(LoadingContext);
        const {setErrorMessage} = useContext(MessageContext);
        const [barcodesHeaders, setBarcodesHeaders] = useState({});
        const [issuedHeaders, setIssuedHeaders] = useState({});

        useEffect(() => {
            const loadBenefitStatistics = async () => {
                try {
                    setLoading(true);
                    setErrorMessage(null);
                    const resObj = await getTotalIssued(benefitId)
                    setStatisticsObj(resObj)
                    setBarcodesHeaders(barcodesHeaders)
                    setIssuedHeaders(issuedHeaders)
                } catch (e) {
                    setErrorMessage(e);
                }
                setLoading(false);
            }

            loadBenefitStatistics();
        }, [benefitId, issuedHeaders, barcodesHeaders, setLoading, setErrorMessage])

        return (
            <Box
                className={classes.root}
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
            >
                {barcodesHeaders  ? (
                        <Typography fontSize={22} component="h3">Total - {statisticsObj?.total}, issued
                            - {statisticsObj?.issued}</Typography>)
                    : (<Typography fontSize={22} component="h3">No data</Typography>)
                }
            </Box>
        );
    }
;